/**
 * The runtime config keys vision_web requires. Shared by the browser config loader
 * (config.js) and the dev-server middleware (vite.config.js) so both validate the same set.
 */
export const REQUIRED_CONFIG_KEYS = [
  'FIREBASE_API_KEY',
  'FIREBASE_AUTH_DOMAIN',
  'FIREBASE_PROJECT_ID',
  'FIREBASE_STORAGE_BUCKET',
  'FIREBASE_MESSAGING_SENDER_ID',
  'FIREBASE_APP_ID',
  'VISION_GRPC_BASE_URL',
  'VISION_WS_BASE_URL',
  'VISION_MEDIA_BASE_URL',
];
